export enum Miljo {
  UTV = "utv",
  TEST = "test",
  PROD = "prod",
}
export enum Sprak {
  NO = "no",
  NN = "nn",
  EN = "en",
}
